export const resetIntegrationToDraft = ({ token, id }) => ({
  HTTPMethod: "post",
  path: `/api/v1/conduit/integrations/${encodeURIComponent(id)}/reset_to_draft`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
